interface Props {
  className?: string;
  titleWords: { content: string; colorGradient: string }[];
  description?: string;
  textClassName?: string;
  titleWordsClassName?: string;
}

const Heading = ({
  className = "",
  titleWords = [],
  description,
  textClassName = "",
  titleWordsClassName = "",
}: Props) => {
  return (
    <div className={`${className}`}>
      {/** Title */}
      <div className={`flex flex-wrap gap-3 druk-font ${titleWordsClassName}`}>
        {titleWords?.map(({ content, colorGradient }, i) => (
          <h2
            style={{
              background: colorGradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            key={i}
            className={`uppercase font-italic tracking-tighter text-[41px] 1366px:text-[44px] 1520px:text-[48px] 192px:text-[54px] 3440px:text-[100px] leading-[.9] ${textClassName}`}
          >
            {content}
          </h2>
        ))}
      </div>
      {/** Description */}
      {description && (
        <p className="gilroy-font leading-4 mt-2 text-[13px] 1520px:text-[14px] 3440px:text-[28px] text-white/50 3440px:leading-8">
          {description}
        </p>
      )}
    </div>
  );
};

export default Heading;
